module.exports = __webpack_public_path__ + "img/ele.d38c9aed.png";